<div class="wide-with-sidebar">
  <div class="container">
    <div class="title">{{ title | translate }}</div>
    <lib-spacer [height]="5"></lib-spacer>
    <div class="subtitle">{{ subtitle | translate }}</div>

    <lib-spacer></lib-spacer>

    <div class="step-container">
      <app-process-step-item
        *ngFor="let step of steps"
        [data]="step"
        [isActive]="step.step <= activeStep"
      >
      </app-process-step-item>
    </div>
  </div>

  <div class="main">
    <div class="content-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
